import { caseFeature } from './case.reducer'
import { createSelector } from '@ngrx/store'
import { MarkerDimension, SegObjectPropertyMap } from './case.state'

export const {
    selectCaseId,
    selectCaseName,
    selectCaseMarkers,
    selectCaseSegObjectPropertyMap,
    selectCaseSegObjectPropertyMaps,
    selectCaseRcnResults,
    selectCaseNeighborhoodEnrichmentResults,
    selectCaseCellTypeDetectionResults,
    selectCaseTsneResults,
    selectCaseUmapResults,
    selectCasePlottingResults,
    selectIsSharedCase,
} = caseFeature

export const selectHasCaseId = createSelector(
    selectCaseId,
    (caseId: number | null): boolean => caseId !== null
)

export const selectHasMarkers = createSelector(
    selectCaseMarkers,
    (markers: MarkerDimension[]): boolean => markers.length > 0
)

export const selectHasSegObjectPropertyMap = createSelector(
    selectCaseSegObjectPropertyMap,
    (segobjectpropertymap: SegObjectPropertyMap | undefined): boolean =>
        segobjectpropertymap !== undefined
)

export const selectHasSegObjectPropertyMaps = createSelector(
    selectCaseSegObjectPropertyMaps,
    (segobjectpropertymaps: SegObjectPropertyMap[]): boolean => segobjectpropertymaps.length > 0
)
